import React from 'react';
import { PageLayout } from '../modules/PageLayout';

export default function DSG(props) {
  return <PageLayout {...props} />;
}
